// "Visa på kartan" (kartvy's listings rail, listvy's cards): once the map has flown to a home, its own marker hops
// twice, a high hop and a low one, with a shadow on the ground under it, and lands lit (design A "Hopp" of the
// 2026-11-02 "Visa på kartan-animation" canvas, the owner's pick; it replaced two green rings). No layer of its
// own: the marker drawn at the point (a DOM house icon at the closest zoom) is found once the view's markers have
// settled after the fly, and animated by a class (`.is-locate-hop`, kartvyList.css). Kartvy keeps the home lit
// (`focusedListId`), so its hop ends grown and glowing; where it isn't (listvy) the glow fades as it lands. A home in
// a group with a count (homes at one address) opens the group first, so its own marker shows and hops.
const FIND_MS = 3000; // the markers are rebuilt on moveend (a busy frame can take a second), and a new one may still be growing in
const HOP_MS = 1300;
const NEAR_PX = 24;

const findMarkerAt = (map, latlng) => {
    const container = map.getContainer();
    const box = container.getBoundingClientRect();
    const point = map.latLngToContainerPoint(latlng);
    let best = null;
    let bestDistance = NEAR_PX;
    container.querySelectorAll('.listing-shape-marker').forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (!rect.width) return;
        const distance = Math.hypot(rect.left + rect.width / 2 - box.left - point.x, rect.top + rect.height / 2 - box.top - point.y);
        if (distance < bestDistance) {
            best = el;
            bestDistance = distance;
        }
    });
    return best;
};

const hop = (el) => {
    const wrapper = el.parentElement;
    const shadow = document.createElement('span');
    shadow.className = 'listing-locate-shadow';
    wrapper?.insertBefore(shadow, el);
    el.classList.remove('is-locate-hop');
    void el.offsetWidth; // restart when the same home is shown again
    el.classList.add('is-locate-hop');
    window.setTimeout(() => {
        el.classList.remove('is-locate-hop');
        shadow.remove();
    }, HOP_MS + 50);
};

// The drawn DOM markers holding the listing (`__listingIds`, set by both views): its own, or the group it's in.
const findMarkersOf = (map, id) => {
    let own = null;
    let group = null;
    map.eachLayer((layer) => {
        const ids = layer.__listingIds;
        if (!layer._icon || !Array.isArray(ids) || !ids.includes(id)) return;
        if (ids.length === 1) own = layer;
        else if (!group && layer.options?.interactive !== false) group = layer;
    });
    return { own, group };
};

// `listingId` (optional): when the home sits in a group with a count (homes at one address, which never split),
// the group is opened as a click on it would (it spreads its homes round the point), and the home's own marker
// hops once it has glided out.
export const pulseListingAt = (map, latlng, listingId) => {
    if (!map) return;
    const id = listingId != null ? String(listingId) : null;
    const reduced = Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
    let started = performance.now();
    let opened = false;
    const look = () => {
        if (!map.getContainer()?.isConnected) return;
        if (id) {
            const { own, group } = findMarkersOf(map, id);
            const el = own?._icon?.querySelector?.('.listing-shape-marker');
            if (el) {
                if (!reduced) hop(el);
                return;
            }
            if (group && !opened) {
                opened = true;
                started = performance.now(); // the spread's glide comes first
                group.fire('click');
            }
        } else if (!reduced) {
            const el = findMarkerAt(map, latlng);
            if (el) {
                hop(el);
                return;
            }
        }
        if (performance.now() - started < FIND_MS) requestAnimationFrame(look);
    };
    // Two frames, so the moveend's marker update has drawn.
    requestAnimationFrame(() => requestAnimationFrame(look));
};
